import { render } from "./PowerBIConnector.vue?vue&type=template&id=f73ce796&scoped=true"
import script from "./PowerBIConnector.vue?vue&type=script&lang=js"
export * from "./PowerBIConnector.vue?vue&type=script&lang=js"

import "./PowerBIConnector.vue?vue&type=style&index=0&id=f73ce796&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73ce796"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
